// Gnome & Dragon Interactive Theme Scripts
document.addEventListener('DOMContentLoaded', () => {
  console.log('Gnome & Dragon Storefront Theme Initialized.');
});
